import {useState, useEffect, useLayoutEffect, useCallback} from 'react'
import {getEl, getViewportRect} from '../helpers/tour'
const useSpotlight = ({step, rectResolver}) => {
    const [rect, setRect] = useState(null)

    const update = useCallback(() => {
        if (!step) {
            setRect(null)
            return
        }
        const el = getEl(step.target)

        // Extension point: allow custom viewport rect (e.g., canvas later)
        if (typeof rectResolver === 'function') {
            const vp = rectResolver(step, el)
            if (vp && typeof vp.top === 'number') {
                const top = Math.max(0, vp.top)
                const left = Math.max(0, vp.left)
                const width = Math.min(window.innerWidth - left, vp.width)
                const height = Math.min(window.innerHeight - top, vp.height)
                const raw = new DOMRect(left, top, width, height)
                setRect({top, left, width, height, raw})
                return
            }
        }

        if (!el) {
            setRect(null)
            return
        }
        setRect(getViewportRect(el, step.offset ?? 8))
    }, [step, rectResolver])

    useLayoutEffect(() => {
        update()
        if (!step) return
        const el = getEl(step.target)
        if (!el) return

        const onEvt = () => update()
        window.addEventListener('scroll', onEvt, true)
        window.addEventListener('resize', onEvt)

        // Observe only the target element for attribute/size changes,
        // NOT document.body with subtree:true — that causes infinite loops
        // because setRect() triggers a React re-render which mutates the DOM.
        const mo = new MutationObserver(onEvt)
        mo.observe(el, {attributes: true, childList: false, subtree: false})

        let ro
        if (window.ResizeObserver) {
            ro = new ResizeObserver(onEvt)
            ro.observe(el)
        }

        return () => {
            window.removeEventListener('scroll', onEvt, true)
            window.removeEventListener('resize', onEvt)
            mo.disconnect()
            ro && ro.disconnect()
        }
    }, [step, update])

    // Ensure visibility (for element targets)
    useEffect(() => {
        if (!step) return
        const el = getEl(step.target)
        if (!el) return
        const r = el.getBoundingClientRect()
        const fullyVisible = r.top >= 0 && r.left >= 0 && r.bottom <= window.innerHeight && r.right <= window.innerWidth
        if (!fullyVisible) {
            try {
                el.scrollIntoView({block: 'center', inline: 'center', behavior: 'smooth'})
            } catch {}
        }
    }, [step])

    return rect

    // const [rect, setRect] = useState(null)
    //
    // const update = useCallback(() => {
    //     if (!step) {
    //         setRect(null)
    //         return
    //     }
    //     const el = getEl(step.target)
    //
    //     // Extension point: allow custom viewport rect (e.g., canvas later)
    //     if (typeof rectResolver === 'function') {
    //         const vp = rectResolver(step, el)
    //         if (vp && typeof vp.top === 'number') {
    //             const top = Math.max(0, vp.top)
    //             const left = Math.max(0, vp.left)
    //             const width = Math.min(window.innerWidth - left, vp.width)
    //             const height = Math.min(window.innerHeight - top, vp.height)
    //             const raw = new DOMRect(left, top, width, height)
    //             setRect({top, left, width, height, raw})
    //             return
    //         }
    //     }
    //
    //     if (!el) {
    //         setRect(null)
    //         return
    //     }
    //     setRect(getViewportRect(el, step.offset ?? 8))
    // }, [step, rectResolver])
    //
    // useLayoutEffect(() => {
    //     update()
    //     if (!step) return
    //     const el = getEl(step.target)
    //     if (!el) return
    //
    //     const onEvt = () => update()
    //     window.addEventListener('scroll', onEvt, true)
    //     window.addEventListener('resize', onEvt)
    //
    //     const mo = new MutationObserver(onEvt)
    //     mo.observe(document.body, {attributes: true, childList: true, subtree: true})
    //
    //     let ro
    //     if (window.ResizeObserver) {
    //         ro = new ResizeObserver(onEvt)
    //         ro.observe(el)
    //     }
    //
    //     return () => {
    //         window.removeEventListener('scroll', onEvt, true)
    //         window.removeEventListener('resize', onEvt)
    //         mo.disconnect()
    //         ro && ro.disconnect()
    //     }
    // }, [step, update])
    //
    // // Ensure visibility (for element targets)
    // useEffect(() => {
    //     if (!step) return
    //     const el = getEl(step.target)
    //     if (!el) return
    //     const r = el.getBoundingClientRect()
    //     const fullyVisible = r.top >= 0 && r.left >= 0 && r.bottom <= window.innerHeight && r.right <= window.innerWidth
    //     if (!fullyVisible) {
    //         try {
    //             el.scrollIntoView({block: 'center', inline: 'center', behavior: 'smooth'})
    //         } catch {}
    //     }
    // }, [step])
    //
    // return rect
}

export default useSpotlight
